import LzMBase from '@lz-models/commons/Base';

export default class MeshModel extends LzMBase {

    constructor(model) {
        super(model);

        this.grain_id = +(model?.grain_id || 0);
        this.grain_name = model?.grain_name || '';
    }

    static parseArray(data) {
        return LzMBase.parseArray(data, MeshModel);
    }

}
